angular.module("digitalLeasing.module").component("commissions", {
    templateUrl: "ng/components/digitalLeasing/financialData/commissions/commissions.view.html",
    bindings: {
        model: "=",
        onCommissionsChange: "&?",
        provvigioni: '<',
        amount: '<',
        validations: '<',
        financialModel: '=',
        leasingData: '<',
        callQuote: '&',
        snapshot: '<',
        validateComponent: '&',
        checkCalcCanoneTassoRun: '&',
        enableCanone: '&',
        startCalcolaCanoneTasso: '<'
    },
    controllerAs: "commissionsCtrl",
    controller: CommissionsController
});

function CommissionsController(
    $financialService,
    PianoFinanziario,
    $timeout,
    $storageService,
    $configService
) {
    var self = this;
    self.amountChange = false;
    self.$onInit = function () {
        self.ImportoDiRiferimento = self.amount;
        var value = {
            currency: self.model.importo,
            percent: self.model.percentuale
        }
        self.resume = true;
        self.handleCommissionsChange('importPerc', value);

        self.checkPreventivLevel2 = $configService.getAppConfig().allFunctionalities.includes("PREVENTIVO_LEVEL2");
        self.checkPreventivLevel3 = $configService.getAppConfig().allFunctionalities.includes("PREVENTIVO_LEVEL3");
        self.disabledCommissions = !(self.model.forzate || self.model.digitate) || (!self.checkPreventivLevel2 || !self.checkPreventivLevel3)

    };

    self.$onChanges = function (changes) {

        if (changes.provvigioni && changes.provvigioni.currentValue) {
            if (changes.provvigioni.riferimentoCalcoloProvvigioni == 'I') {
                self.ImportoDiRiferimento = self.amount;
            } else if (changes.provvigioni.riferimentoCalcoloProvvigioni == 'I-A') {
                self.ImportoDiRiferimento = self.amount - self.leasingData.preventivo.pianoFinanziario.anticipo.importo
            }
            $timeout(function () {
                self.model = changes.provvigioni.currentValue;
                self.model.percentuale = changes.provvigioni.currentValue.percentuale;
                self.model.importo = changes.provvigioni.currentValue.importo;
                if ((!self.checkPreventivLevel2 && !self.checkPreventivLevel3)) {
                    self.disabledCommissions = true;
                } else {

                    self.disabledCommissions = !(self.model.forzate || self.model.digitate)
                }
            }, 2000)

        }


        if (changes.validations && changes.validations.currentValue) {
            if (changes.validations.currentValue.fasceProvvigioni.length > 0) {
                self.enableModify = (self.model.forzate || self.model.digitate);
                self.showIcon = false;
                self.model.forzate = false;
                self.model.digitate = true;
            } else {
                self.enableModify = (self.model.forzate || self.model.digitate);
                self.showIcon = true;
                self.model.forzate = self.model.forzate ? self.model.forzate : false;
                self.model.digitate = false;
            }
        }
    }

    self.handleCommissionsChange = function (property, value) {

        if (property == "importPerc") {

            var percModel = Math.round(self.model.percentuale * 10000) / 10000;
            var percValue = Math.round(value.percent * 10000) / 10000;
            jQuery('#percent-provvigioniVenditore').removeClass('has-error');
            jQuery('#currency-provvigioniVenditore').removeClass('has-error');
            if (self.model.importo == value.currency && percModel == percValue) {
                self.resume = false;
                return
            }
            $timeout(function () {
                if (!self.snapshot) {
                    if (!self.model.forzate) {
                        self.model.importo = value.currency;
                        self.model.percentuale = value.percent;
                    }

                    self.model.importo = value.currency;
                    self.model.percentuale = value.percent;



                    if (self.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoOCanoneUtente == 'C') {
                        if (!(self.model.forzate || self.model.digitate))
                        // || value.currency == 0 || value.percent == 0 eliminato questo controllo per mantis 0013113 da rimettere se genera loop
                        {

                            return
                        }
                        if (!self.resume) {
                            calcolaTasso();
                        } else {
                            self.resume = false;
                        }

                    } else {
                        if (!(self.model.forzate || self.model.digitate))
                        // || value.currency == 0 || value.percent == 0 eliminato questo controllo per mantis 0013113 da rimettere se genera loop
                        {
                            return
                        }
                        if (!self.resume) {
                            calcolaCanone();
                            console.log("Chiamata importPercent commissions")

                        } else {
                            self.resume = false;
                        }
                    }
                    jQuery('#percent-provvigioniVenditore').removeClass('has-error');
                    jQuery('#currency-provvigioniVenditore').removeClass('has-error');
                }

            }, 800);
        } else {
            self.model.speseRiconosciute = parseFloat(value.value);
        }


    };

    self.enabledDisabledCommissions = function () {
        jQuery('[data-toggle="tooltipForzata"]').tooltip('hide');
        self.enableModify = !self.enableModify;
        self.model.forzate = self.enableModify;
        self.disabledCommissions = !(self.model.forzate || self.model.digitate)
        if (self.financialModel.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoOCanoneUtente == "N" && !self.model.forzate) {
            self.financialModel.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoOCanoneUtente = "C"
        }

        if (self.financialModel.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoOCanoneUtente != "C") {
            self.financialModel.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoOCanoneUtente = "";
        }
        if (!self.model.forzate) {
            self.enableCanone({
                value: false
            });
            if (self.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoOCanoneUtente == 'C') {
                calcolaTasso();
            } else {
                calcolaCanone();
            }
            console.log("Chiamata forzatura commission")
        } else if (self.model.forzate) {
            self.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoOCanoneUtente = 'C'
            self.enableCanone({
                value: true
            });
            calcolaTasso();
        }

        self.callQuote({
            value: self.enableModify
        });
    }

    var calcolaTasso = function () {
        if (self.snapshot) {
            return
        }
        self.financialModel.leasingData.preventivo.assicurazioni = self.financialModel.leasingData.preventivo.assicurazioni
            .filter(function (e) {
                return e != ""
            })
        var checkAssicurazioni = self.financialModel.leasingData.preventivo.assicurazioni
            .some(function (element) {
                return element.polizze[0].premi.importoPremioAttivo == null ||
                    element.polizze[0].premi.importoPremioAttivo == "undefined"
            })
        if (!self.financialModel.leasingData.preventivo ||
            !self.financialModel.leasingData.preventivo.pianoFinanziario.durataMesi ||
            !self.financialModel.leasingData.preventivo.pianoFinanziario.numeroRate ||
            self.financialModel.leasingData.preventivo.pianoFinanziario.riscatto.importo == null ||
            self.financialModel.leasingData.preventivo.pianoFinanziario.anticipo.importo == null ||
            typeof self.financialModel.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0] == 'undefined' ||
            self.financialModel.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].tassoBase == null ||
            self.financialModel.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].tassoTrasferimento == null ||
            self.financialModel.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].description == null ||
            checkAssicurazioni ||
            (self.financialModel.leasingData.preventivo.pianoFinanziario.provvigioni.digitate && self.financialModel.leasingData.preventivo.pianoFinanziario.provvigioni.importo == null)) {
            return;
        }
        self.calcolaTassoisRunning = true;
        checkPage();
        self.checkCalcCanoneTassoRun({
            value: true
        });
        $financialService.calcolaTasso(self.financialModel.leasingData.preventivo, self.financialModel.financialVendor.reteVendita, self.financialModel.financialVendor.mansioneAziendale, self.financialModel.financialVendor.mansioni)
            .then(function (response) {
                if (response.message) {
                    self.checkCalcCanoneTassoRun({
                        value: false
                    });
                    return;
                }
                self.onCommissionsChange({
                    response: response.pianoFinanziario
                })
                self.financialModel.leasingData.preventivo.pianoFinanziario = PianoFinanziario.build(response.pianoFinanziario);
                self.financialModel.leasingData.preventivo.validations.spreadNetto = response.validations.spreadNetto;
                self.financialModel.leasingData.preventivo.validations.spreadNettoReale = response.validations.spreadNettoReale;

                self.calcolaTassoisRunning = false;
                checkPage();
                self.checkCalcCanoneTassoRun({
                    value: false
                });


            })
            .catch(function (error) {
                self.checkCalcCanoneTassoRun({
                    value: false
                });
                console.log(error);
                self.calcolaTassoisRunning = false;
                checkPage();
            })
    }

    var calcolaCanone = function () {
        if (self.snapshot) {
            return
        }
        if (!self.financialModel.leasingData.preventivo) {
            return
        }
        self.financialModel.leasingData.preventivo.assicurazioni = self.financialModel.leasingData.preventivo.assicurazioni
            .filter(function (e) {
                return e != ""
            })
        var checkAssicurazioni = self.financialModel.leasingData.preventivo.assicurazioni
            .some(function (element) {
                return element.polizze[0].premi.importoPremioAttivo == null ||
                    element.polizze[0].premi.importoPremioAttivo == "undefined"
            })
        if (!self.financialModel.leasingData.preventivo ||
            !self.financialModel.leasingData.preventivo.pianoFinanziario.durataMesi ||
            !self.financialModel.leasingData.preventivo.pianoFinanziario.numeroRate ||
            self.financialModel.leasingData.preventivo.pianoFinanziario.riscatto.importo == null ||
            self.financialModel.leasingData.preventivo.pianoFinanziario.anticipo.importo == null ||
            typeof self.financialModel.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0] == 'undefined' ||
            self.financialModel.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].tassoBase == null ||
            self.financialModel.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].tassoTrasferimento == null ||
            self.financialModel.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].description == null ||
            checkAssicurazioni ||
            (self.financialModel.leasingData.preventivo.pianoFinanziario.provvigioni.digitate && self.financialModel.leasingData.preventivo.pianoFinanziario.provvigioni.importo == null)) {
            return;
        }
        self.calcolaCanoneIsRunning = true;
        checkPage();
        self.checkCalcCanoneTassoRun({
            value: true
        });
        $financialService.calcolaCanone(self.financialModel.leasingData.preventivo, self.financialModel.financialVendor.reteVendita, self.financialModel.financialVendor.mansioneAziendale, self.financialModel.financialVendor.mansioni)
            .then(function (response) {
                if (response && response.pianoFinanziario && typeof response.pianoFinanziario.canone != 'undefined') {
                    self.financialModel.leasingData.preventivo.pianoFinanziario = PianoFinanziario.build(response.pianoFinanziario);
                    self.financialModel.leasingData.preventivo.validations.spreadNetto = response.validations.spreadNetto;
                    self.financialModel.leasingData.preventivo.validations.spreadNettoReale = response.validations.spreadNettoReale;
                    self.onCommissionsChange({
                        response: response.pianoFinanziario
                    });
                }

                self.calcolaCanoneIsRunning = false;
                checkPage();
                self.checkCalcCanoneTassoRun({
                    value: false
                });
            })
            .catch(function (error) {
                self.checkCalcCanoneTassoRun({
                    value: false
                });
                console.log(error);
                self.calcolaCanoneIsRunning = false;
                checkPage();
            })
    }

    var checkPage = function () {
        var test = !self.calcolaCanoneIsRunning &&
            !self.calcolaTassoisRunning
        if (test) {
            self.validateComponent({
                value: false
            })
        } else {
            self.validateComponent({
                value: true
            })
        }
    }
}